import { PendingPayment } from '@shared'

import styles from './TransactionProcessing.module.scss'
import { useOverlayActions } from '@store'
import { useEffect } from 'react'

const TIMEOUT = 5000 // 5 seconds

export const TransactionProcessing = () => {

  const { hideOverlay } = useOverlayActions()

  useEffect(() => {
    setTimeout(() => {
      hideOverlay()
    }, TIMEOUT)
  }, [hideOverlay])

  return (
    <div className={styles.transactionProcessing}>
      <PendingPayment />
    </div>
  )
}
